// extracted by mini-css-extract-plugin
export default {"statisticBlock":"StatisticBlock_statisticBlock__aMdMG","invest":"StatisticBlock_invest__4jKGX"};